import type { ContentBuilder } from '../../ui/ContentBuilder';
import type { Tile } from '../../../engine/hex/types';
import type { HexMapState } from '../../../engine/render/renderer';
import { t } from '../../../i18n/translations';

export function renderTileEnemiesTab(
    builder: ContentBuilder,
    state: HexMapState,
    tile: Tile,
): void {
    const lang = state.config.ui.language;
    if (!state.discoveredTileIds.has(tile.id)) {
        builder.text(t(lang, 'tile.undiscoveredHint'));
        return;
    }
    const enemy = state.enemyForces[tile.id];
    if (!enemy || enemy.defeatedAt) {
        builder.text(t(lang, 'tile.enemiesNone'));
        return;
    }

    const total = enemy.units.reduce((sum, group) => sum + group.count, 0);
    builder.section(t(lang, 'tile.enemiesTitle'), (section) => {
        section.text(t(lang, 'tile.hostileFaction', t(lang, `enemy.${enemy.faction}`)));
        section.text(t(lang, 'tile.hostileCount', total));
        enemy.units.forEach((group) => {
            section.text(
                t(lang, 'tile.enemyUnitLine', t(lang, `enemy.${group.type}`), group.count),
            );
        });
        section.text(t(lang, 'tile.enemiesDevNote'), 'muted');
    });
}
